module.exports = __webpack_public_path__ + "static/media/Navigator.4547374d.svg";